// User popup few second

// $(function () {
//     if (!localStorage.getItem('popupShown')) {
//         $("#hideDiv").fadeIn();

//         setTimeout(function () { 
//             $("#hideDiv").fadeOut(1500); 
//         }, 3000);

//         localStorage.setItem('popupShown', 'true');
//     }
//     $("#closeButton").on("click", function () {
//         $("#hideDiv").fadeOut(500);
//     });
// });


// serchbar 

  const searchBar = document.getElementById('searchBar');
  const wordCarousel = document.querySelector('.wordCarousel');

  searchBar.addEventListener('focus', () => {
    wordCarousel.style.display = 'block';
    searchBar.classList.add('focused');
  });

  searchBar.addEventListener('blur', () => {
    setTimeout(() => {
      wordCarousel.style.display = 'none';
      searchBar.classList.remove('focused');
    }, 200);
  });


// newsletter
document.addEventListener("DOMContentLoaded", function () {
  const successMessage = document.querySelector(".from-success-msg");
  const formWrapper = document.querySelector(".newsletter-form__field-wrapper");
  const inlineRichtext = document.querySelector("h2.inline-richtext.h1");
  const newsletterSubheading = document.querySelector(".newsletter__subheading.rte");

  if (successMessage && successMessage.hasAttribute("tabindex")) {
    if (formWrapper) {
      formWrapper.style.display = "none";
    }
    if (inlineRichtext) {
      inlineRichtext.style.display = "none";
    }
    if (newsletterSubheading) {
      newsletterSubheading.style.display = "none";
    }
  
    successMessage.classList.add("show");
  }
});


// Scroll History

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'auto';
}

const interval = setInterval(() => {
  const bisButton = document.querySelector("a.button.klaviyo-bis-trigger");
  const productButtons = document.querySelector(".product-form__buttons");

  if (bisButton && productButtons) {
    // Move the button inside .product-form__buttons (at the start)
    productButtons.prepend(bisButton);

    // Clear interval after success
    clearInterval(interval);
  }
}, 300); // check every 300ms

